import {Injectable} from '@angular/core';
import {GenericService} from '../../core/commons/generic.service';
import {DynSelectFieldOptions} from '../domain/meta/fields/select/dyn-select-field-options';
import {QueryOptions} from '../../core/commons/query.options';
import {AuthService} from '../../core/security/auth.service';
import {FormUtils} from '../domain/meta/form-utils';

@Injectable()
export class SelectFieldOptionsService
    extends GenericService<DynSelectFieldOptions<any>> {

    constructor(authService: AuthService) {
        super(authService);
    }

    getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    protected valueToEntity(value: Object): DynSelectFieldOptions<any> {
        // console.log(value);
        return FormUtils.parseSelectFieldOptions(value);
    }

    protected getResourcePath(): string {
        return '/forms/select_field_options';
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/services/select-field-options-service.service.ts